export default "__VITE_ASSET__DQkCKXvP__"